import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PolarisStar } from "@/components/site/PolarisStar";
import { HERO_MAIN } from "@/data/content";

export const Hero = () => {
  return (
    <section id="top" className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden">
      <div className="absolute -top-24 -right-24 w-[480px] h-[480px] bg-[#ffc247]/25 va-blob blur-2xl pointer-events-none" />
      <div className="absolute top-40 -left-32 w-[420px] h-[420px] bg-[#12b2a0]/15 va-blob blur-2xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-7"
        >
          <div className="inline-flex items-center gap-2 bg-white border border-[#e4dccf] rounded-full px-4 py-2 mb-7">
            <PolarisStar className="w-4 h-4" />
            <span className="text-xs font-semibold tracking-widest uppercase text-[#6b6873]">
              {HERO_MAIN.overline}
            </span>
          </div>

          <h1 className="font-display text-4xl md:text-5xl lg:text-[3.4rem] font-extrabold tracking-tight leading-[1.08]">
            <span className="text-[#ff5c49]">Polaris.</span> Guiamos a familias, profesionales y
            empresas a través de una combinación de{" "}
            <span className="text-[#12b2a0]">estrategia</span> y soporte ejecutivo.
          </h1>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            <a
              href="#agendar"
              data-testid="hero-cta-agendar"
              className="inline-flex items-center gap-2 bg-[#ff5c49] text-white font-semibold px-7 py-4 rounded-full hover:bg-[#e6452f] transition-colors shadow-lg shadow-[#ff5c49]/25"
            >
              Agendar llamada gratuita <ArrowRight className="w-5 h-5" />
            </a>
            <a
              href="#areas"
              data-testid="hero-cta-areas"
              className="inline-flex items-center gap-2 bg-white border border-[#2b2a33]/15 text-[#2b2a33] font-semibold px-7 py-4 rounded-full hover:border-[#2b2a33] transition-colors"
            >
              Conoce nuestras áreas
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative">
            <div className="absolute -inset-3 bg-[#12b2a0] rounded-[2rem] rotate-3" />
            <img
              src={HERO_MAIN.image}
              alt={HERO_MAIN.imageAlt}
              className="relative rounded-[2rem] w-full h-[440px] md:h-[540px] object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
